<template>
    <section class="awerack_root_wrp">
        <div v-if="isMobile" class="mbl_awerack_option_wrp">
            <div class="row">
                <div class="col-md-12 text-right">
                    <button class="btn btn-primary" @click="openMblLeftSideBar">Tools</button>
                </div>
            </div>
            <div class="mbl_awerack_left_sidebar_wrp" v-if="mblLeftSidebaar" v-click-outside="closeMblLeftSideBar">
                <pp-left-sidebar></pp-left-sidebar>
            </div>
        </div>
        <div class="row">
            <div class="col-md-auto ml-md-auto pr-md-1 desk_left_sidebar" v-if="!isMobile"
                :class="leftSidebarHideState ? 'hide' : ''">
                <pp-left-sidebar></pp-left-sidebar>
            </div>
            <div class="col-md pl-md-0">
                <div class="awerack_content_wrp">
                    <span class="left_arrow_btn_f_sidebar" :class="leftSidebarHideState ? 'actv' : ''"
                        @click="leftSidebarHideMethod"><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */

import ppLeftSidebar from '../paperpile-left-sidebar';

export default {
    name: 'awerack-root',
    components: {
        'pp-left-sidebar': ppLeftSidebar,
    },
    props: [],
    data() {
        return {
            isMobile: false,
            mblLeftSidebaar: false,
            leftSidebarHideState: false
        }
    },
    computed: {

    },
    mounted() {

    },
    created() {
        window.addEventListener('resize', this.onResize, { passive: true })
        this.onResize()
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    methods: {
        leftSidebarHideMethod() {
            if (this.leftSidebarHideState) {
                this.leftSidebarHideState = false
            } else {
                this.leftSidebarHideState = true
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 769
        },
        openMblLeftSideBar() {
            if (this.mblLeftSidebaar == true) {
                this.mblLeftSidebaar = false
            } else {
                this.mblLeftSidebaar = true
            }
        },
        closeMblLeftSideBar() {
            this.mblLeftSidebaar = false
        }
    }
}
</script>

<style lang="scss" scoped>
.awerack_root_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .mbl_awerack_option_wrp {
        padding: 5px 15px;
        background: rgba(0, 0, 0, 0.75);

        .btn-primary {
            cursor: pointer;
            position: relative;
            min-width: 95px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: rgba(255, 255, 255, 0.12);
            color: #ffffff;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 18px;
        }
    }

    .mbl_awerack_left_sidebar_wrp {
        position: fixed;
        z-index: 1000;
        background: #000;
        top: 120px;
    }

    .awerack_content_wrp {
        position: relative;
        height: 100%;

        .left_arrow_btn_f_sidebar {
            display: block;
            text-align: center;
            font-size: 24px;
            color: #ffd400;
            cursor: pointer;
            position: absolute;
            top: 35vh;
            left: -12px;
            z-index: 2;
            width: 20px;
            height: 90px;
            background: rgba(79, 79, 79, 0.5);
            border-radius: 4px;
            line-height: 90px;

            &:hover {
                background: #87cefa;
                color: #22292f;
            }

            .fa {
                transform: rotate(0deg);
                -webkit-transform: rotate(0deg);
                -moz-transform: rotate(0deg);
                transition: transform ease 0.2s;
                -webkit-transition: transform ease 0.2s;
                -moz-transition: transform ease 0.2s;
            }

            &.actv {
                background: #87cefa;
                color: #22292f;

                .fa {
                    transform: rotate(180deg);
                    -webkit-transform: rotate(180deg);
                    -moz-transform: rotate(180deg);
                }
            }

            @media only screen and (max-width:768px) {
                display: none !important;
            }
        }
    }

    .desk_left_sidebar {
        transition: width ease 0.3s;
        -webkit-transition: width ease 0.3s;
        -moz-transition: width ease 0.3s;
        width: 279px;

        &.hide {
            width: 0px;
            overflow: hidden;
        }
    }
}
</style>

<style lang="scss">
@media only screen and (max-width:769px) {
    .paperpile_section_wrp {
        .paperpile_content_header {
            .rfiles_main_heading {
                font-size: 20px !important;
            }

            .rfiles_header_right_side {
                margin-top: 10px;
            }
        }

        .paperpile_content_list_inner {
            &>li {
                padding: 10px !important;

                label {
                    padding: 0px !important;
                }
            }

            .rfiles_action_list_wrp {
                flex-wrap: wrap;
                gap: 10px;

                li {
                    margin-right: 0px !important;
                    padding: 5px 15px !important;
                    font-size: 14px !important;
                    line-height: 16px !important;
                }
            }
        }
        .create_paperpile_popup {
            padding: 0px !important;
            .paper_tabs {
                .tab_item{
                    padding: 7px !important;gap: 0px !important;
                    span{font-size: 16px !important;margin-top: 2px !important;}
                    .fa{font-size: 22px !important;}
                }
            }
            .tab_content{padding: 10px !important;}
            .paper_upload_div .upload_attachment_btn label{font-size: 18px !important;}
        }
    }
}
</style>